import { render, staticRenderFns } from "./VehicleAddContract.vue?vue&type=template&id=67593c37&scoped=true&"
import script from "./VehicleAddContract.vue?vue&type=script&lang=js&"
export * from "./VehicleAddContract.vue?vue&type=script&lang=js&"
import style0 from "./VehicleAddContract.vue?vue&type=style&index=0&id=67593c37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67593c37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67593c37')) {
      api.createRecord('67593c37', component.options)
    } else {
      api.reload('67593c37', component.options)
    }
    module.hot.accept("./VehicleAddContract.vue?vue&type=template&id=67593c37&scoped=true&", function () {
      api.rerender('67593c37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehicleAddContract.vue"
export default component.exports